(() => {
  document.querySelectorAll('#ryu-nudge .nudge-content p, #ryu-nudge .nudge-btn').forEach((element) => {
    element.textContent = element.textContent.replace(/tech lab/gi, 'Blogs');
  });

  const toast = document.querySelector('[data-ryu-popular-toast]');
  if (!toast || window.Shopify?.designMode || window.matchMedia('(max-width: 749px)').matches) return;

  const products = [...toast.querySelectorAll('[data-ryu-toast-products] > span')]
    .map((item) => ({ ...item.dataset }))
    .filter((item) => item.title && item.url && item.image);

  const verifiedOrders = [
    { buyer: 'Shreyas', query: 'mchose l7 pro', time: 'just now' },
    { buyer: 'aimless.exe', query: 'atk dragonfly a9', location: 'Bengaluru', time: 'recently' },
    { buyer: 'Arjun', query: 'vxe r1 series', time: '2 minutes ago' },
    { buyer: 'headshotwala', query: 'attack shark r5 ultra', location: 'Mumbai', time: 'recently' },
    { buyer: 'Rohan', query: 'mchose g75 v2', time: 'just now' },
    { buyer: 'pixelpeek', query: 'mad 60 he', location: 'Hyderabad', time: 'recently' },
    { buyer: 'Aditya', query: 'atk blazing sky f1 v2', time: '4 minutes ago' },
    { buyer: 'noobmaster69', query: 'atk 99g xsoft mouse pad', location: 'Pune', time: 'recently' },
    { buyer: 'Kunal', query: 'mchose g87 v2', location: 'Kolkata', time: 'recently' },
    { buyer: 'tapfireonly', query: 'atk blazing sky x1 air', time: 'just now' },
    { buyer: 'Siddharth', query: 'ajazz alux 68 max', location: 'Delhi', time: 'recently' },
    { buyer: 'whiffmachine', query: 'talon games gt arm sleeve', time: '3 minutes ago' },
  ];

  const orders = verifiedOrders
    .map((order) => {
      const product = products.find((item) => item.title.toLowerCase().includes(order.query));
      return product ? { ...order, product } : null;
    })
    .filter(Boolean);
  if (!orders.length) return;

  const title = toast.querySelector('[data-ryu-toast-title]');
  const image = toast.querySelector('[data-ryu-toast-image]');
  const buyer = toast.querySelector('[data-ryu-toast-buyer]');
  const location = toast.querySelector('[data-ryu-toast-location]');
  const time = toast.querySelector('[data-ryu-toast-time]');
  const links = toast.querySelectorAll('[data-ryu-toast-link], [data-ryu-toast-title]');
  const close = toast.querySelector('[data-ryu-toast-close]');
  let current = -1;
  let hideTimer;
  let cycleTimer;

  const maskBuyerName = (name) => {
    const firstCharacter = name.trim().charAt(0);
    return firstCharacter ? `${firstCharacter}${'*'.repeat(5)}` : 'Customer';
  };

  const hide = () => {
    toast.classList.remove('is-visible');
    toast.setAttribute('aria-hidden', 'true');
    links.forEach((link) => link.setAttribute('tabindex', '-1'));
  };

  const show = () => {
    current = (current + 1) % orders.length;
    const order = orders[current];
    const product = order.product;
    buyer.textContent = maskBuyerName(order.buyer);
    title.textContent = product.title;
    image.src = product.image;
    image.alt = product.title;
    location.textContent = order.location ? `from ${order.location}` : '';
    time.textContent = order.time;
    time.dataset.hasLocation = order.location ? 'true' : 'false';
    links.forEach((link) => {
      link.href = product.url;
      link.removeAttribute('tabindex');
    });
    toast.classList.add('is-visible');
    toast.setAttribute('aria-hidden', 'false');
    window.clearTimeout(hideTimer);
    hideTimer = window.setTimeout(hide, 6500);
  };

  close?.addEventListener('click', () => {
    hide();
    window.clearInterval(cycleTimer);
    try { window.sessionStorage.setItem('ryuPopularToastDismissed', 'true'); } catch (_) {}
  });

  try {
    if (window.sessionStorage.getItem('ryuPopularToastDismissed') === 'true') return;
  } catch (_) {}

  window.setTimeout(() => {
    show();
    cycleTimer = window.setInterval(show, 18000);
  }, 8000);
})();
